/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgTriangleBase = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 9 9" fill="none" {...props}>
    <path
      d="M5.24242 1.22256C5.18951 1.11483 5.10746 1.02408 5.00558 0.960624C4.90371 0.897164 4.78609 0.863525 4.66606 0.863525C4.54604 0.863525 4.42842 0.897164 4.32654 0.960624C4.22467 1.02408 4.14262 1.11483 4.0897 1.22256L0.721486 8.08414C0.680942 8.16662 0.662085 8.25807 0.666697 8.34986C0.671309 8.44165 0.699236 8.53074 0.747843 8.60874C0.79645 8.68674 0.864133 8.75107 0.944502 8.79565C1.02487 8.84022 1.11528 8.86359 1.20718 8.86353H8.12494C8.21685 8.86359 8.30725 8.84022 8.38762 8.79565C8.46799 8.75107 8.53567 8.68674 8.58428 8.60874C8.63289 8.53074 8.66081 8.44165 8.66543 8.34986C8.67004 8.25807 8.65118 8.16662 8.61064 8.08414L5.24242 1.22256Z"
      fill="currentColor"
    />
  </svg>
);
const SvgTriangle = wrapIcon(SvgTriangleBase);
export default SvgTriangle;
